<script>
import { mapState, mapActions } from 'vuex';
import validatorMixin from '../../mixins/validatorMixin';

export default {
  name: 'FerryCarTypeEdit',
  props: {
    shown: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    ...mapState({
      carType: state => state.transportation.carTypes.carType,
      saveError: state => state.transportation.carTypes.saveError,
      saveLoading: state => state.transportation.carTypes.saveLoading,
    }),
    changesMade() {
      const changes = JSON.stringify(this.current) !== JSON.stringify(this.carType);
      this.$emit('input', changes);
      return changes;
    },
  },
  methods: {
    ...mapActions({
      saveCarType: 'transportation/carTypesSave',
    }),
    saveEditCarType() {
      if (this.validForm && this.changesMade) {
        this.saveCarType(this.current)
          .then((res) => {
            if (res) {
              this.$emit('close', true);
            }
          });
      }
    },
    formatDistance(distance) {
      return `${distance} ${this.$t('measures.cm')}`;
    },
  },
  data() {
    return {
      validForm: true,
      current: undefined,
    };
  },
  watch: {
    shown() {
      if (this.shown) {
        this.current = { ...this.carType };
        this.$emit('input', this.changesMade);
      }
    },
  },
  mixins: [validatorMixin],
};
</script>

<template>
  <v-card v-if="carType && current">
    <v-form v-model="validForm" @submit.prevent="saveEditCarType">
      <v-card-title>
        <span class="headline">
          {{ $t('transportation.carTypes.actions.edit.title') }}
        </span>
      </v-card-title>

      <v-card-text class="py-0 mb-3 edit-item-status">
        <v-progress-linear
          class="my-0"
          v-if="saveLoading"
          :active="saveLoading"
          :indeterminate="true"
          :height="4"
        />
        <v-alert
          class="my-0 py-2"
          outline
          v-if="!saveLoading"
          :value="!!saveError"
          transition="slide-y-transition">
          {{ $t('transportation.carTypes.actions.edit.error') }}
        </v-alert>
      </v-card-text>

      <v-card-text class="py-0">
        <v-container grid-list-md pt-1>
          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="current.name"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Supplier name"
              />
            </v-flex>
          </v-layout>

          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="current.externalRef"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="External reference"
              />
            </v-flex>
          </v-layout>

          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="current.height"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Height (in cm)"
                type="number"
              />
            </v-flex>
          </v-layout>

          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="current.length"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Length (in cm)"
                type="number"
              />
            </v-flex>
          </v-layout>

          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="current.webName"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Web Name"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-checkbox
                v-model="current.active"
                :disabled="saveLoading"
                label="Active"
                class="mt-0"
                hide-details
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="red darken-1"
          flat
          @click="$emit('close')">
          {{ $t('inputs.actions.cancel') }}
        </v-btn>
        <v-tooltip top :disabled="changesMade">
          <template slot="activator" slot-scope="{ on }">
            <div v-on="on">
              <v-btn
                :disabled="!validForm || saveLoading || !changesMade"
                color="blue darken-1"
                type="submit"
                flat>
                {{ $t('inputs.actions.save') }}
              </v-btn>
            </div>
          </template>
          <span>
            {{ $t('inputs.misc.saveDisabled') }}
          </span>
        </v-tooltip>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style lang="scss">
  .edit-item-status {
    min-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/transportation/TransportationCarTypesEdit.vue